import { differenceInCalendarDays } from 'date-fns';
import { FlightCore } from './flight';
import { Flight } from './searchCriteria';

export namespace FlightsWidgets {
  const NEARBY_DATES_SIZE = 10;

  export class NearbyDates {
    dates: DateCell[];

    constructor(dates: DateCell[]) {
      this.dates = dates;
    }

    static tripDuration = (a: Date, b?: Date): number => {
      return b ? differenceInCalendarDays(b, a) : 0;
    };

    static build = (criteria: Flight.SearchCriteria) => {
      const today = new Date();

      const duration = this.tripDuration(
        criteria.departDate,
        criteria.tripType === FlightCore.TripType.RoundTrip ? criteria.returnDate : null
      );

      const shiftDateFrom = (numOfDays: number, date: Date): Date => {
        const daysAgo = new Date(date.getTime());
        daysAgo.setDate(date.getDate() + numOfDays);
        return daysAgo;
      };

      const composeDates = (): DateCell[] => {
        const remainingDaysUntilTrip = this.tripDuration(today, criteria.departDate);

        let iDate =
          remainingDaysUntilTrip < NEARBY_DATES_SIZE / 2
            ? today
            : shiftDateFrom((NEARBY_DATES_SIZE / 2) * -1, criteria.departDate);
        const dates: DateCell[] = [];

        while (dates.length < NEARBY_DATES_SIZE) {
          const returnDate =
            criteria.tripType === FlightCore.TripType.RoundTrip
              ? shiftDateFrom(duration, iDate)
              : null;

          const isSelected = this.tripDuration(criteria.departDate, iDate) === 0;
          const date: DateCell = {
            departureDate: iDate,
            returnDate,
            isSelected,
            price: null,
            isCheapest: false,
          };
          dates.push(date);
          iDate = shiftDateFrom(1, iDate);
        }

        return dates;
      };

      return new NearbyDates(composeDates());
    };
  }

  export interface DateCell {
    departureDate: Date;
    returnDate?: Date;
    price?: number | string;
    isSelected: boolean;
    isCheapest: boolean;
  }
}
